import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MapPinIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.08 20.06V13.7C8.76 13.26 7.04 11.22 7.04 8.82C7.04 6.1 9.24 3.86 12 3.86C14.76 3.86 16.96 6.1 16.96 8.82C16.96 11.22 15.24 13.26 12.92 13.7V20.06H11.08ZM8.82 8.82C8.82 10.56 10.2 12.06 12 12.06C13.8 12.06 15.18 10.56 15.18 8.82C15.18 7.08 13.8 5.58 12 5.58C10.2 5.58 8.82 7.08 8.82 8.82Z" />
    </SvgIcon>
  );
});
